angular.module('app.core').factory('parametroBMPFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'ParametroBMP';

    var _findRecord = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord');
    };

    var _save = function (isNew, dto) {
        var method = isNew ? 'Insert' : 'Update';
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + method, dto);
    };

    var factory = {};
    factory.findRecord = _findRecord;
    factory.save = _save;

    return factory;

}]);
